module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAARBAMAAAAmgTH3AAAAMFBMVEUAAAD/aZb/aY/6aZH7aY/8aZD9aY/9aZD7aY/8aY/8aY/8aY/9aY/8aY/8aY/8aY/wq9I5AAAAD3RSTlMAESIzRFVmd4iZqrvM3e5GKvWZAAAAZUlEQVQI102Ouw1AYACED6XYQKEwh5hDZQMTSGyi0VvBBkb5E/FsfPzxvOpyuZckxaksnBIaSxJOVJJn9gxWKWBUDakKZvnQqYXc6RlkOKWQSTYTuSyPMn+eN/X2XM3bb+tbv/8c51lMqQ4aMZQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/circle-right.png
// module id = 676
// module chunks = 0